/**
 * @generated SignedSource<<5465f3e0b6a11a55b01489ba592a1eb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
export type WidgetWeatherSize = "ONE_X_ONE" | "TWO_X_ONE";
import { FragmentRefs } from "relay-runtime";
export type useWidgetToPosSingleSize_widget$data = {
  readonly __typename: string;
  readonly noteSize?: WidgetNoteSize;
  readonly overviewSize?: WidgetOverviewSize;
  readonly size?: WidgetWeatherSize;
  readonly taskSingleSize?: WidgetTaskSingleSize;
  readonly turnpikeSize?: WidgetIntegrationTurnpikeSize;
  readonly " $fragmentType": "useWidgetToPosSingleSize_widget";
};
export type useWidgetToPosSingleSize_widget$key = {
  readonly " $data"?: useWidgetToPosSingleSize_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"useWidgetToPosSingleSize_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useWidgetToPosSingleSize_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overviewSize",
          "storageKey": null
        }
      ],
      "type": "WidgetOverview",
      "abstractKey": "__isWidgetOverview"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noteSize",
          "storageKey": null
        }
      ],
      "type": "WidgetNote",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskSingleSize",
          "storageKey": null
        }
      ],
      "type": "WidgetTaskSingle",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        }
      ],
      "type": "WidgetWeather",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "turnpikeSize",
          "storageKey": null
        }
      ],
      "type": "WidgetIntegrationTurnpike",
      "abstractKey": null
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};

(node as any).hash = "21333e2684da34b2cd45b8e47d697e4b";

export default node;
